
    import './styles.scoped.css';
    export default {
  "css-grid": "awsui_css-grid_zqq3x_1vv2s_181",
  "grid-no-gutters": "awsui_grid-no-gutters_zqq3x_1vv2s_192",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_zqq3x_1vv2s_195",
  "item": "awsui_item_zqq3x_1vv2s_195",
  "first-column": "awsui_first-column_zqq3x_1vv2s_212"
};
  